import React, { useState, useEffect} from 'react';
import { configData } from "../config";
import { Link, useNavigate} from 'react-router-dom';
import MinicartLength from './MinicartLength';
import Loading from './Loading';
import ReactDOM from "react-dom/client";

function SezzlePaymentNotify() {
    
    const app_url = configData.APP_URL;
    const navigate = useNavigate();
    const order_id = localStorage.getItem('order_id');

    useEffect(()=>{
        SezzleSuccessNotify(order_id);
    },[])

    async function SezzleSuccessNotify(order_id) {
        const postData = {
          order_id: order_id
          }
       const response = await fetch(app_url+'smwwcommercepayment/notifysezzlepayment', {
              method: 'POST',
              body: JSON.stringify(postData),
              headers: {
                'Content-Type': 'application/json',
              },
              });
              const data = await response.json();
              if(data.data.result === "Success") {
                //  window.gtag("event", "purchase",  {
                //   "transaction_id":data.data.order_details['transaction_id'],
                //    "value":data.data.order_details['order_total'],
                //     "shipping":data.data.order_details['shipping_amount'],
                //    "currency": "USD",
                //     "items": data.data.order_details['items']
                //  });
                const order_id = localStorage.getItem('drupal_orderid');
                localStorage.removeItem("order_id");
                localStorage.removeItem("drupal_orderid");
                 const root = ReactDOM.createRoot(document.getElementById("top-header-cart-icon"));
                 root.render(<MinicartLength length={0} />);
                    navigate("/smww/checkout/thankyou/"+data.data.order_details['transaction_id']);
              } else {
               
              }
      }
      return (
        <><div style={{ margin: "0 auto",maxWidth: 1170,width: "100%",textAlign: "center",fontSize: "35px",
          color: "#000",
          fontWeight: "900",
          marginTop: "20px" }}>Please wait until your order is complete.</div><Loading /></>
      );
}
export default SezzlePaymentNotify;